import { makeStyles } from '@material-ui/core/styles';
export default makeStyles((theme) => ({

    navbar:{
        // display:"flex",
        // paddingTop:"10px",
        // paddingBottom:"10px",
        // paddingInline:"40px",
        // "@media (max-width:400px)":{
        //     paddingTop:"15px",
        // paddingBottom:"15px",
        // paddingInline:"10px"},
        // "@media (max-width:320px)":{
        //     paddingTop:"10px",
        // paddingBottom:"10px",
        // paddingInline:"10px",
        // }
        position:"fixed",
        width:"100%",
        zIndex:"3",
        "@media (max-width:450px)":{
            background: "#fff",
            top:"0px",
            padding:"5px 0px"
        },
        ["@media (max-height:550px)"]: {
            background: "#fff",
            top:"0px",
            padding:"5px 0px"
          },
    },
    accountAddress:{
        padding:"9px 10px",
        fontSize:"16px",
        "@media (max-width:550px)":{
            padding:"9px 5px",
        fontSize:"12px",
        }
    },
    navbarMaterial:{
        display:"flex",
        paddingTop:"10px",
        paddingBottom:"10px",
        paddingInline:"40px",
        alignItems: "center",
        // background: "#fff",
        "@media (max-width:550px)":{
            paddingTop:"0px",
        paddingBottom:"0px",
        paddingInline:"10px"},
        "@media (max-width:320px)":{
            paddingTop:"0px",
        paddingBottom:"0px",
        paddingInline:"10px",
        },
        ["@media (max-height:550px)"]: {
            paddingTop:"0px",
        paddingBottom:"0px",
        paddingInline:"10px",
          },
    },
    navbarMetamask:{
        display: "flex",
        background: "#fff",
        borderRadius: "44px",
        alignItems: "center",
        paddingInline: "10px",
        "@media (max-width:550px)":{
        display: "none",
        }
    },
    networkIcon:{
        minWidth:"36px",
        height:"25px"
    },
    navbarAddress:{
        display: "flex",
        background: "#FFDF00",
        borderRadius: "44px",
        filter: "drop-shadow(0px 0px 30px rgba(0, 0, 0, 0.07))",
        alignItems: "center",
        cursor: "pointer",
        "&:hover":{
            background: "#f7d905",
        }
    },
    
    leftNetworkDropDown:{
    left:"65px",
    "@media (max-width:550px)":{
        left:"20px"
    }  
    },
    help:{
        alignItems:"center",
        background:"#fff",
        boxShadow:"0px 0px 30px rgb(0 0 0 / 7%)",
        borderRadius:"50%",
        padding:"10px 16px",
        marginLeft:"20px",
        "@media (max-width:550px)":{
            marginLeft:"5px",
            alignSelf:"center",
            padding:"5px 12px"
        }
    },
    menuItem:{
       "& span": {
           fontSize: "18px",lineHeight: "23px"/* identical to box height */

        /* Wireframe/Blue/Secondary */
        
        ,color: "#282828",
        fontWeight:"500",
        fontFamily:"Mulish"
    }},
    logoDiv:{
        paddingTop:"5px",
        paddingBottom:"5px",
        alignSelf:"center",
        "@media (max-width:400px)":{
            paddingTop:"5px",
        paddingBottom:"5px",},
        "@media (max-width:320px)":{
            paddingTop:"5px",
        paddingBottom:"5px",
            }
    },
    mContentLogo:{
        height:"33px",
        "@media(max-width:550px)":{
            height:"28px"
        }
        },
    marginLeftAuto:{
        marginLeft:"auto"
    },
    root: {
        display: 'flex',
      },
      paper: {
        marginRight: theme.spacing(2),
      },
      downDrop:{
        display:"flex",
        alignItems:"center"
      },
      chainIconHeight:{
          width: "22px",
        "@media (max-width:550px)":{
            height:"18px",
            width: "18px"
        }
      },
      downArrowIcon:{
        "@media (max-width:550px)":{
            height:"6px"
        }
      },
      chainButton:{
          borderRadius:"20px",
          marginRight:"10px",
          alignItems:"center",
          boxShadow: "0px 0px 30px rgb(0 0 0 / 7%)",
          "@media (max-width:550px)":{
            marginRight:"5px",
            // padding:"5px 5px",
        fontSize:"12px",
        }
      }
  }), {index: 1});
  